import React, { useEffect, useState  } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { base_url,Apitoken, Authtoken  } from "../Global";
import "react-toastify/dist/ReactToastify.css";
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';

import { loader_image } from "../_components/Imagepath";
import Select from 'react-select';
import $ from "jquery";
import Swal from 'sweetalert2';
import {
  MenuItem,
} from '@mui/material';
const Contracts = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [permission, setPermission] = useState({});

  const [customerList, setCustomerList] = useState([]);


  const options = [
      { value: '1', label: "Confirmed" },
    { value: '2', label: "Finished" },
    { value: '3', label: "In Process" },
    { value: '4', label: "Draft" } ,
    { value: '5', label: "Cancelled" }
  ];

  const [filterdownloadbtn, setFilterdownloadbtn] = useState(false);


  const handleSelectChange = (selectedOptions) => {
    setFormData({ ...formData, order_stats: selectedOptions ? selectedOptions.map(option => option.value) : [] });
  };
   const handleSelectChangeCustomer = (selectedOption) => {
    setFormData({ ...formData, customer: selectedOption ? selectedOption.value : null });
  };
  

  const [formData, setFormData] = useState({
    customer:'',
    order_stats: [],
    start_eta_week:'',
    end_eta_week:'',
    
  });
 

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
    .post("/contracts/listing", formData, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }) .then((response) => {
      if (response.data.code === 200) {
        setData(response.data.data.contracts);
        setFilterdownloadbtn(true);
        $("#filtered-excel-button").show();
      } 
      else {
         //setBackendErrors(response.data.error);
      }
    })
    .catch((error) => {
      console.log(error)
     // actions.setSubmitting(false);
    });
  
  }





  const deleteItem = (item) => {

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/contracts/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/contracts";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }

  useEffect(() => {
        setPermission(FindModuleById(452)); 
      console.log(permission);
  axios
      .get("/helpers/contracts-status", {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let orders_status = response.data.data.orders_status;
          setStatusOptions(orders_status);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
   
   
        axios.post("/customers/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }}).
          then((response) => {
            if (response.data.code === 200) {
              let incoterms = response.data.data.customers;
              let customerListing = incoterms.map((cust, index) => ({
                label: cust.company_name,
                value: cust.id,
                key: `types-${index}`,
              }));
              setCustomerList(customerListing);
            }
     
    })
    .catch((error) => {
      console.log(error);
    });

    axios.post("/contracts/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
      .then((response) => {
        setData(response.data.data.contracts);
      }).catch((error) => {console.log(error);});

    

   
  }, []);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


 
  
  const editItem = (item)=>{
    window.location.href = "/contracts-edit/"+item;
  }
  // const viewItem = (item)=>{
  //   window.location.href = "/orders-view/"+item;
  // }
  const PONumberCell = ({ row }) => {
    return (
      <a href={`/contracts-view/${row.original.id}`} className="">
        {row.original.contract_number}
      </a>
    );
  };
  
  // ✅ Define PropTypes
  PONumberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        contract_number: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  };
  const OrderStatusCell = ({ row, statusOptions, changeOrderStatus}) => {
    return (
      <div className="btn-group custom-table-btn-group">
        <button
          type="button"
          className="btn btn-block dropdown-toggle me-1"
          id={`status-all-${row.original.id}`}
          style={{
            backgroundColor: row.original.contractstatus.bg_color,
            color: row.original.contractstatus.color,
          }}
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {row.original.contractstatus ? row.original.contractstatus.title : ''}
        </button>
        <div className="dropdown-menu">
          {statusOptions &&
            statusOptions.map((shipp) => (
              <button
                key={shipp.id}
                className="dropdown-item btn btn-block"
                style={{ backgroundColor: shipp.bg_color, color: shipp.color }}
                onClick={() => changeOrderStatus(row.original.id, shipp.id, 'all')}
              >
                {shipp.title}
              </button>
            ))}
        </div>
      </div>
    );
  };
  
  // ✅ Define PropTypes
  OrderStatusCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        contractstatus: PropTypes.shape({
          title: PropTypes.string,
          bg_color: PropTypes.string,
          color: PropTypes.string,
        }),
      }).isRequired,
    }).isRequired,
    statusOptions: PropTypes.array.isRequired,
    changeOrderStatus: PropTypes.func.isRequired,
  };
  const columns = [
    {
      header: 'Contract Number',
      accessorFn: (row) => `${row.contract_number}`,
      Cell: PONumberCell, // ✅ Use the separate component
    },
    {
      header: 'Customer',
      accessorFn: (row) => `${row.customer_detail ? row.customer_detail.company_name : ''}`,
    },
   
    {
      header: 'Product',
      accessorFn: (row) => `${row.producttype ? row.producttype.title : ''}`,
    },
   
    {
      accessorKey: 'price',
      header: 'Price',
    },
     {
      accessorKey: 'quantity',
      header: 'Quantity',
    },
     {
      accessorKey: 'quantity_loaded',
      header: 'Quantity Loaded',
    },
     {
      accessorKey: 'remaining_quantity',
      header: 'Remaining Quantity',
    },
     {
      accessorKey: 'progress_status',
      header: 'Progress Status',
    },

    {
      header: 'Status',
      accessorFn: (row) => `${row.contractstatus ? row.contractstatus.title : ''}`,
      Cell: (props) => <OrderStatusCell {...props} statusOptions={statusOptions} changeOrderStatus={changeOrderStatus}  />,
    },
  
 
    {
      header: 'Created By',
      accessorFn: (row) =>
        `${row.createdby ? row.createdby.first_name + ' ' + row.createdby.last_name : ''}`,
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        `${row.updatedby ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ''}`,
    },
    {
      header: 'Updated At',
      accessorFn: (row) => `${formatDateTime(row.updated_at)}`,
    },
  ];
  
  
          const formatDateTime = (isoString) => {
            const date = new Date(isoString);
          
            // Get the components
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            let hours = date.getHours();
            const minutes = String(date.getMinutes()).padStart(2, '0');
          
            // Determine AM/PM
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert to 12-hour format
          
            return `${year}-${month}-${day} ${hours}:${minutes} ${ampm}`;
          };
    
    const changeOrderStatus = (user_id, status,type) =>{

    Swal.fire({
      title: 'Do you want Change Status?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: 'green',
      cancelButtonColor: '#d33',
      confirmButtonText: 'CONFIRM',
      customClass: "swal-orders"
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/contracts/change-status/${user_id}/${status}`, {headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },})
            .then((response) => {
             // console.log(response.data.data.order_status);
              if (response.data.code === 200) {
                $("#status-"+type+"-"+user_id).text(response.data.data.order_status.title);
                $("#status-"+type+"-"+user_id).css('background-color',response.data.data.order_status.bg_color);
                $("#status-"+type+"-"+user_id).css('color',response.data.data.order_status.color);

        
                
                Swal.fire(
                  'Changed!',
                  'Contract Status has been changed Successfully.',
                  'success'
                );
                 axios.post("/contracts/listing",{},{headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }, })
                    .then((response) => {
                      setData(response.data.data.contracts);
                    }).catch((error) => {console.log(error);});

              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });


   
  
  }

  function objectToQueryString(obj) {
    return Object.keys(obj)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        .join('&');
}
  const downloadExcel = (e) => {

    console.log(e);
    let order_statss = formData.order_stats;
      let all_status = [];
      order_statss.map((brk, index) => {
        console.log(index);
        all_status.push(brk.value);
    });
    let all_status2 = all_status.toString();
    formData.status = all_status2;
    console.log(formData);

    $("#loader-image2").removeClass('loader-hide2');
    $("#loader-image2").addClass('loader-show2');
    const queryString = objectToQueryString(formData);
    // axios.get(`/orders/listing-excel?${queryString}`,  {
    //          //responseType: 'blob',
    //         headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    //      }).then(response => {
    //       console.log(response);
              window.open(`${base_url}/contracts/orders-excel?${queryString}`, '_blank');

              $("#loader-image2").addClass('loader-hide2');
              $("#loader-image2").removeClass('loader-show2');
             
          // })
          // .catch(error => {
          //     console.error('Error downloading PDF:', error);
          // });
  }

  const downloadExcelFiltered = (e) => {
    console.log(e);
    console.log(formData);
    let order_statss = formData.order_stats;
      let all_status = [];
      order_statss.map((brk, index) => {
        console.log(index);
        all_status.push(brk.value);
    });
    let all_status2 = all_status.toString();
    formData.status = all_status2;
    console.log(formData);

    $("#loader-image3").removeClass('loader-hide2');
    $("#loader-image3").addClass('loader-show2');
    const queryString = objectToQueryString(formData);
    // axios.get(`/orders/listing-excel?${queryString}`,  {
    //          //responseType: 'blob',
    //         headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    //      }).then(response => {
    //       console.log(response);
              window.open(`${base_url}/contracts/orders-excel?${queryString}`, '_blank');

          //     $("#loader-image3").addClass('loader-hide2');
          //     $("#loader-image3").removeClass('loader-show2');
             
          // })
          // .catch(error => {
          //     console.error('Error downloading PDF:', error);
          // });
  }
  return (
    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />  
      {/* <ToastContainer /> */}

      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Contracts</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li className="breadcrumb-item active">Contracts</li>
                </ul>
              </div>
              <div className="col-auto">
              {permission && permission.add === 1 && (
                  <Link to="/contracts-add" className="btn btn-primary me-1">
                  <i className="fas fa-plus"></i>
                </Link>
                )} 
                &nbsp;&nbsp;
                  {permission && permission.list === 1 && (
                  <button
                  className="btn btn-primary"
                  onClick={() => downloadExcel()}
                >
                  <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i><img id="loader-image2" className="loader-image2 loader-hide2" src={loader_image}/>
                </button> 
                )}   
              </div>
            </div>
          </div>
          <div id="filter_inputs" className="card filter-card2">
              <div className="card-body p-10">
                <form onSubmit={handleSubmit}>
                <div className="row">
                <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Customer:</label>
                    
                        <Select
                           
                           options={customerList}
                           name="customer"
                           value={customerList.find(option => option.value === formData.customer) || null} 
                           onChange={(selectedOption) => handleSelectChangeCustomer(selectedOption)}
                          />
                    </div>
                  </div>
                 
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Select Contract Status:</label>
                   
                             <Select
                                isMulti
                                options={options}
                                name="order_stats"
                                value={options.filter(option => formData.order_stats?.includes(option.value))} 
                                onChange={(selectedOptions) => handleSelectChange(selectedOptions)}
                              />

                    </div>
                  </div>
               
                
                  <div className="col-md-2">
                    <div className="pt-4 mt-2">
                      <button type="submit" className="btn btn-primary">
                        Filter
                      </button>
                      &nbsp;&nbsp;
                      <a href="/contracts" className="btn btn-primary me-1"><i className="fa fa-times"></i></a> &nbsp;&nbsp;
                      {filterdownloadbtn == true && (
                        <button
                          className="btn btn-primary"
                          id="filtered-excel-button"
                          //style={{display:'none'}}
                          onClick={() => downloadExcelFiltered()}
                        >
                          <i className="fa fa-file-excel-o"></i>  <i className="fa fa-download"></i>
                          {/* <img id="loader-image3" className="loader-image2 loader-hide2" src={loader_image}/> */}
                        </button> 
                      )}
                      
                        
                    </div>
                  </div>
                </div>
                </form>
                
              </div>
            </div>
         

          <div className="row">
            <div className="col-sm-12">
            {permission && permission.list === 1 && (
            <section className="comp-section order-listing-page">
                <div className="row">
                <div className="col-md-12">
                    <div className="card bg-white">
                    
                    <div className="card-body">
                       
                          <div className="table-responsive">
                                  <MaterialReactTable columns={columns} data={data} 
                                        enableColumnOrdering
                                        enablePinning
                                        enableRowActions
                                        enableSorting={true} // Enable sorting
                                        initialState={{  pagination: { pageSize: 100 }, }} // Use the accessorKey for sorting
 
                                         renderRowActionMenuItems={({ row }) => [
                                          permission?.update === 1 && (
                                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                              Edit
                                            </MenuItem>
                                          ),
                                          permission?.delete === 1 && (
                                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                              Delete
                                            </MenuItem>
                                          ),
                                        ]}
                                      />
                                  </div>

                                                  
                    </div>
                    </div>
                </div>
                </div>
            </section>
            )}
             
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Contracts;
